import {
    useMemo,
} from 'react'

import moment from 'moment'
import clsx from 'clsx'
import dateTimeStandardMask from 'app/utils/date/dateTimeStandardMask'
import getReadingThresholdType, {
    ReadingThresholdType,
} from 'app/utils/getReadingThresholdType'
import {
    LoggerType,
} from 'app/enums/label.enums'
import useStyles from './TemperatureAge.style'

type Props = {
    specialColorCodingProperty?: LoggerType
    value?: string,
    className?: string,
}

const defaultProps = {
    value: undefined,
    className: undefined,
    specialColorCodingProperty: undefined,
}

export default function Age({
    value,
    className,
    specialColorCodingProperty,
}: Readonly<Props>) {
    const {
        classes,
    } = useStyles()

    const readingType = useMemo(() => {
        return getReadingThresholdType(value, specialColorCodingProperty)
    }, [
        value,
        specialColorCodingProperty,
    ])

    const style = useMemo(() => {
        return clsx({
            [classes.oldReading]: readingType === ReadingThresholdType.OLD,
            [classes.recentReading]: readingType === ReadingThresholdType.RECENT,
            [classes.liveReading]: readingType === ReadingThresholdType.LIVE,
        })
    }, [
        classes,
        readingType,
    ])

    return (
        <div
            data-testid="age-div"
            className={clsx(style, className)}
        >
            <span className={classes.capitalize}>
                {Boolean(value) && `${moment.utc(value, dateTimeStandardMask).fromNow(true)}`}
            </span>
        </div>
    )
}

Age.defaultProps = defaultProps
